function createAxiosInstance (options, interceptors) {
  const instance = axios.create(options)
  if (interceptors) {
    if (interceptors.request &&
      typeof interceptors.request.onFulfilled === 'function' &&
      typeof interceptors.request.onRejected === 'function') {
      instance.interceptors.request.use(interceptors.response.onFulfilled, interceptors.response.onRejected)
    }
    if (interceptors.response && 
      typeof interceptors.response.onFulfilled === 'function' &&
      typeof interceptors.response.onRejected === 'function') {
      instance.interceptors.response.use(interceptors.response.onFulfilled, interceptors.response.onRejected)
    }
  }
  
  return instance
}